import {
  BinaryOutcome,
  NonBinaryOutcome,
} from 'src/interviews/components/TxocInterview/machine/types';
import { ISupplierCardConfig } from 'src/packages/polaris/types/interviews';

type GetSupplierCardConfigProps = {
  outcome: BinaryOutcome | NonBinaryOutcome;
  supplierCtaCardConfigs: ISupplierCardConfig[];
};

export function getSupplierCardConfig({
  outcome,
  supplierCtaCardConfigs,
}: GetSupplierCardConfigProps) {
  switch (outcome) {
    case BinaryOutcome.Approved:
      return supplierCtaCardConfigs?.find((config) => config.variant === BinaryOutcome.Approved);
    case BinaryOutcome.Denied:
      return supplierCtaCardConfigs?.find((config) => config.variant === BinaryOutcome.Denied);
    case NonBinaryOutcome.MoreInfo:
      return supplierCtaCardConfigs?.find((config) => config.variant === NonBinaryOutcome.MoreInfo);
    default:
      return null;
  }
}

type GetSecondaryCtaConfigOptions = {
  isDenied: boolean;
};
export function getSecondaryCtaConfig(options: GetSecondaryCtaConfigOptions) {
  return options.isDenied
    ? {
        link: 'https://cmwldirect.com/collections/all?_ef_transaction_id=&oid=4&affid=3',
        label: 'Explore other CMWL products to help you lose weight',
      }
    : {
        link: 'https://centerformedicalweightloss.com/virtual-plans?_ef_transaction_id=&oid=5&affid=3',
        label: 'Learn more about CMWL semaglutide program',
      };
}
